import { Navigate, Route, Routes } from "react-router-dom";
import LoginPage from "../login/LoginPage";
import OidcAuth from "../login/OidcAuth";

export const PublicRoutes = () => {
  return (
    <Routes>
      <Route path="login" element={<LoginPage />} />
      <Route path="auth" element={<OidcAuth />} />
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};
